import { Component } from '@angular/core';

@Component({
  selector: 'opus-merch-landing',
  templateUrl: './merch-landing.component.html',
})
export class MerchLandingComponent { }
